import { map } from 'lodash'
import { forwardRef, useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type RelationshipTypesMultiSelectInput_query$key } from '@/__generated__/RelationshipTypesMultiSelectInput_query.graphql'
import { MultiSelectInput, type MultiSelectInputProps, type MultiSelectInputRef, type SelectOption } from '@/components'

export type RelationshipTypesMultiSelectInputProps = Omit<MultiSelectInputProps, 'options'> & {
  queryRef: RelationshipTypesMultiSelectInput_query$key | null | undefined
}

export const RelationshipTypesMultiSelectInput = forwardRef<
  MultiSelectInputRef,
  RelationshipTypesMultiSelectInputProps
>(({ queryRef, ...props }, ref) => {
  const queryData = useFragment(
    graphql`
      fragment RelationshipTypesMultiSelectInput_query on Query {
        relationshipTypes(orderBy: [SEQUENCE_ASC]) {
          nodes {
            name
            rowId
          }
        }
      }
    `,
    queryRef
  )

  return (
    <MultiSelectInput
      options={useMemo<SelectOption[]>(
        () =>
          map(queryData?.relationshipTypes?.nodes, (relationshipType) => ({
            label: relationshipType!.name,
            value: relationshipType!.rowId
          })),
        [queryData?.relationshipTypes?.nodes]
      )}
      ref={ref}
      {...props}
    />
  )
})

RelationshipTypesMultiSelectInput.displayName = 'RelationshipTypesMultiSelectInput'
